var render = function render(){var _vm=this,_c=_vm._self._c;return _c('documents-component',{attrs:{"is-project":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }